// Clipboard backend validation utility
import { useEffect, useRef, useState } from "react"
import { BackendHook, Clip } from "./types"

/**
 * Hook for subscribing to clips from a backend
 * Handles the subscription pattern and cleanup automatically
 */
export const useBackendClips = (
  activeBackend: ReturnType<BackendHook> | null
): Clip[] => {
  const [clips, setClips] = useState<Clip[]>([])
  const subscriptionRef = useRef<() => void>(() => {})

  useEffect(() => {
    if (activeBackend) {
      try {
        const unsubscribe = activeBackend.subscribeToClips((backendClips) => {
          setClips(backendClips)
        })
        subscriptionRef.current = unsubscribe
        return unsubscribe
      } catch (err) {
        console.warn(`[Clipboard] subscribeToClips failed for backend:`, err)
        setClips([])
      }
    } else {
      setClips([])
    }
    // Cleanup on unmount
    return () => {
      if (subscriptionRef.current) subscriptionRef.current()
    }
  }, [activeBackend])

  return clips
}

export function validateBackend(
  backend: ReturnType<BackendHook> | null | undefined
): boolean {
  if (!backend) return false
  if (typeof backend.isAvailable !== "function") return false
  if (typeof backend.subscribeToClips !== "function") return false
  if (typeof backend.saveClips !== "function") return false
  // getName is optional
  return true
}
